import $ from 'jquery';
import tabbable from 'tabbable';
import { basePathname, pushBack, replace } from './store/history.js';
import transitionEndWrapper from './utils/transition-end.js';

const defaultOptions = {
	openClass: 'module--open',
	skipSelector: '.js-skip',
	backSelector: '.js-back',
	closeSelector: '.js-close',
	titleSelector: '.js-title',
	stepSelector: '.js-step',
	stepTitleSelector: '.js-step-title',
	openCallback: undefined
};

function rollbackTabKey() {
	const items = Array.prototype.slice.call(document.querySelectorAll('[tabindex="-1"]'));

	items.forEach((item) => {
		const savedTabIndex = item.dataset.tabIndex;
		if (savedTabIndex != undefined) {
			item.dataset.tabIndex = null;
			item.setAttribute('tabindex', savedTabIndex);
		}
	});
}

function prepareTabKey(container) {
	rollbackTabKey();

	const allItems = Array.prototype.slice.call(tabbable(document));
	const	currentItems = Array.prototype.slice.call(tabbable(container));

	allItems.forEach((item) => {
		const tabindex = item.getAttribute('tabindex') || 0;
		if (currentItems.indexOf(item) === -1) {
			if (tabindex !== -1) {
				item.dataset.tabIndex = tabindex;
				item.setAttribute('tabindex', '-1');
			}
		}
	});
}


function Flow(view, content, options) {
	this.view = view;

	this.options = $.extend({}, defaultOptions, options);

	this.skipButton = this.view.querySelector(this.options.skipSelector);
	this.backButton = this.view.querySelector(this.options.backSelector);
	this.closeButton = this.view.querySelector(this.options.closeSelector);
	this.title = this.view.querySelector(this.options.titleSelector);

	this.$steps = $(this.options.stepSelector);

	$(this.backButton).on('click.flowBack', () => {
		pushBack();
	});

	$(this.closeButton).on('click.flowClose', () => {
		replace(basePathname());
	});

	this.steps = content;

	this.currentStep = undefined;
}

Flow.prototype.open = function (step) {
	if (this.currentStep == null) {
		this.view.classList.add(this.options.openClass);
	}
	if (this.currentStep === step) { // same step
		return;
	}

	this.currentStepView = null;

	this.update(this.currentStep, step);
	this.options.openCallback && this.options.openCallback.call(this);
	this.currentStep = step;

	document.documentElement.classList.add('overlay--open');

};

Flow.prototype.getStepIndex = function (step) {
	return Object.keys(this.steps).indexOf(step);
};

Flow.prototype.update = function (previousStep, currentStep) {
	this.previousState = this.steps[previousStep];
	this.currentState = this.steps[currentStep];

	const $currentStep = this.$steps.eq(this.currentState.order);
	const $previousStep = this.previousState && this.$steps.eq(this.previousState.order);
	const title = $currentStep.find(this.options.stepTitleSelector).html();

	this.toggle(this.backButton, this.currentState.back);
	this.toggle(this.closeButton, this.currentState.close);
	this.toggle(this.skipButton, this.currentState.skip);


	this.title.innerHTML = title || '';

	if (!this.isOpened) {
		this.view.classList.add(this.options.openClass);
		this.isOpened = true;
	}

	this.previousState && $previousStep.removeClass(this.previousState.openClass).addClass(this.previousState.closeClass);
	$currentStep.removeClass(this.currentState.closeClass).addClass(this.currentState.openClass);

	this.currentState.action && this.currentState.action.call(this, this.view);

	this.currentStepView = $currentStep[0];

	transitionEndWrapper(this.currentStepView, prepareTabKey);
};

Flow.prototype.toggle = function (element, toggle) {
	if (element && element.classList) {
		element.classList.toggle('u-show', toggle);
		element.classList.toggle('u-hide', !toggle);
	}
};

Flow.prototype.close = function () {
	this.isOpened = false;
	this.currentStep = null;

	this.$steps.eq(this.currentState.order).removeClass(this.currentState.openClass).addClass(this.currentState.closeClass);

	// @TODO fix
	this.view.classList.remove(this.options.openClass);

	this.options.closeCallback && this.options.closeCallback.call(this);
	document.documentElement.classList.remove('overlay--open');

	rollbackTabKey();
};

export default Flow;



// WEBPACK FOOTER //
// ./mobile-core/src/flow.js